import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonRadioGroupCustomEvent, RadioGroupChangeEventDetail } from '@ionic/core';
import { BuddySettingsService } from '../services/buddy-settings.service';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-buddy-language',
    templateUrl: './buddy-language.component.html',
    styleUrls: ['./buddy-language.component.scss'],
})
export class BuddyLanguageComponent {
    constructor(
        private modalCtrl: ModalController,
        public buddySettingsService: BuddySettingsService,
    ) {}

    onLanguageSelected(event: IonRadioGroupCustomEvent<RadioGroupChangeEventDetail>) {
        this.buddySettingsService.selectedLanguageIndex = event.detail.value;
        localStorage.setItem('selectedLanguageIndex', `${this.buddySettingsService.selectedLanguageIndex}`);
    }

    dismiss() {
        this.modalCtrl.dismiss();
    }
}
